import React from 'react';
import { Helmet } from 'react-helmet';

import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';

import { customTheme } from '@hydra/common/styles';
import { useI18n } from '@hydra/common/customHooks';
import { Shell } from '@hydra/types/shell';

const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  }
});

interface AppShellProps extends Shell {}

export default function AppShell ({ children }: AppShellProps) {
  const { translate } = useI18n();
  const classes = useStyles();
  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <div className={classes.root}>
        <Helmet>
          <title>{`WooRank | ${translate('baseline')}`}</title>
        </Helmet>
        {children}
      </div>
    </ThemeProvider>
  );
}
